import { Card, makeStyles, Paper } from '@material-ui/core'
import React, { useContext, useState } from 'react'
import { getChordsSuggestions } from '../util/smartChordsUtils'
import { getChordsInRange } from '../util/utils'
import BackingTrackEditorContext from './editorStore/BackingTrackGeneratorEditorContext'
import { Chord } from './editorStore/backingTrackGeneratorEditorState'
import EditorSmallChordCard from './mainControls/EditorSmallChordCard'

import { Carousel } from 'react-responsive-carousel'
import 'react-responsive-carousel/lib/styles/carousel.min.css'

import ChevronRightIcon from '@material-ui/icons/ChevronRight'
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft'
import { EditorActionType } from './editorStore/backingTrackGeneratorEditorActions'

import MusicVideoIcon from '@material-ui/icons/MusicVideo'
// import DoubleArrowIcon from '@material-ui/icons/DoubleArrow'

const useStyles = makeStyles({
  container: {
    position: 'absolute',
    left: 0,
    top: -52,
    display: 'flex',
    flexDirection: 'row',
    zIndex: 7,
    transition: 'opacity ease 0.25s',
  },
  card: {
    display: 'flex',
    flexDirection: 'row',
    marginRight: 16,
    position: 'relative',
  },
  cardLast: {
    display: 'flex',
    flexDirection: 'row',
    position: 'relative',
  },
  element: {
    display: 'flex',
    flexDirection: 'row',
    width: 272,
  },
  element2: {
    marginRight: 12,
    whiteSpace: 'nowrap',
  },
  next: {
    position: 'absolute',
    right: -28,
    top: 5,
    opacity: 0.4,
    cursor: 'pointer',
    transition: 'opacity ease 0.25s',
    '&:hover': {
      opacity: 1,
    }
  },
  prev: {
    position: 'absolute',
    left: -28,
    top: 5,
    opacity: 0.4,
    cursor: 'pointer',
    transition: 'opacity ease 0.25s',
    '&:hover': {
      opacity: 1,
    }
  },
  iconOpen: {
    marginTop: 16,
    opacity: 0.3,
    cursor: 'pointer',
    transition: 'opacity ease 0.25s',
    '&:hover': {
      opacity: 0.6,
    }
  }
})

const ChordProgressionSuggestions = (props: {
  hide?: boolean,
}) => {

  const {
    hide = false,
  } = props

  const classes = useStyles()

  const [editor, dispatchEditor] = useContext(BackingTrackEditorContext)

  const [suggestionHover, setSuggestionHover] = useState(-1)

  const chords = getChordsInRange(editor.chords, editor.state.chordSelectedRanges[0])
  
  const suggestions = getChordsSuggestions(editor.config.scale, chords)

  const [open, setOpen] = useState(false)

  const handleMouseOver = (e: any, i: number) => {
    setSuggestionHover(i)
  }

  const handleMouseOut = (e: any, i: number) => {
    setSuggestionHover(-1)
  }

  const handleChordCardClick = (e: any, suggestion: any) => {
    dispatchEditor({
      type: EditorActionType.ProgressionAdd,
      payload: {
        chords: suggestion.chords,
      }
    })
  }
  
  console.log({ suggestions })

  return (
    <div
      onClick={(e) => e.stopPropagation()}
      onMouseDown={(e) => e.stopPropagation()}
      className={classes.container}
      style={{ opacity: hide ? 0 : 1 }}
    >
      {open ? (
        <Carousel
          autoPlay={false}
          width={272}
          showThumbs={false}
          showIndicators={false}
          renderArrowNext={(onClick, hasNext) => <ChevronRightIcon className={classes.next} style={{ opacity: hasNext ? undefined : 0, cursor: hasNext ? undefined : 'auto' }} onClick={onClick} />}
          renderArrowPrev={(onClick, hasNext) => <ChevronLeftIcon className={classes.prev} style={{ opacity: hasNext ? undefined : 0, cursor: hasNext ? undefined : 'auto' }} onClick={onClick} />}
          // showStatus={false}
          // transitionTime
        >
          {Array.from(Array(Math.ceil(suggestions.length / 2))).map((_, i: number) =>
            <div className={classes.element}>
              {suggestions.slice(i * 2, i * 2 + 2).map((suggestion: any, j: number) => (
                <Card
                  key={i * 2 + j}
                  className={j === 1 ? classes.cardLast : classes.card}
                  onMouseEnter={(e: any) => handleMouseOver(e, i * 2 + j)}
                  onMouseLeave={(e: any) => handleMouseOut(e, i * 2 + j)}
                  onClick={(e: any) => handleChordCardClick(e, suggestion)}
                >
                  {suggestion.chords.map((chord: Chord) => (
                    <EditorSmallChordCard
                      chord={chord}
                      selected={i * 2 + j === suggestionHover}
                      tiny
                    />
                  ))}
                </Card>
                // <div className={classes.element}>{suggestion.chords.map((c: Chord) => c.degreeName).join('-') + ' ' + suggestion.score.toFixed(4)}</div>
                // <div className={classes.element}>{suggestion.degrees.join('-')}</div>
              ))}
            </div>
          )}
        </Carousel>
      ): (
        <MusicVideoIcon className={classes.iconOpen} onClick={() => setOpen(true) } />
      )}
    </div>
  )
}

export default ChordProgressionSuggestions
